import React from "react";
import styled from "styled-components";

import UIPrimaryWidgetBox from "components/UI/PrimaryWidgetBox";
import FeeNumbersCard from "../FeeNumbersCard";

const Container = styled.div.attrs({ className: "fee-cards" })`
  .widget {
    display: flex;
    max-width: 900px;
  }
  .card {
    border-right: ${props => `1px solid ${props.theme.colors.silverAlt}`};
    flex: 1;
    padding: 24px 24px 10px;
  }
  .card.registration .border-bot {
    background: ${props => props.theme.colors.vividBlue};
  }
  .card.plates .border-bot {
    background: ${props => props.theme.colors.softCyan};
  }
`;

const AnalyticsDashboardFeeCards = ({ className }) => {
  return (
    <Container className={className}>
      <UIPrimaryWidgetBox className="widget">
        <FeeNumbersCard
          className="card"
          title="Title Fees"
          left="249"
          right="1100"
        />
        <FeeNumbersCard
          className="card registration"
          title="Registration Fees"
          left="280"
          right="1340"
        />
        <FeeNumbersCard
          className="card plates"
          title="Plates Fees"
          left="581"
          right="1437"
        />
      </UIPrimaryWidgetBox>
    </Container>
  );
};

export default AnalyticsDashboardFeeCards;
